module.exports = __webpack_public_path__ + "media/images/application/newsletter/banner-newsletter-2a1ce12c6ba5e350b7546003da63af7d.jpg";